import { featureCreditGovernanceV094 } from '@/config/featureFlags';
import { runDefaultCharge } from '@/core/credit/creditActionOrchestrator';

const chargeErrorTextMap = Object.freeze({
    insufficient_credits: {
        titleKey: 'billing.notices.insufficientCredits.title',
        messageKey: 'billing.notices.insufficientCredits.message'
    },
    unavailable_tier: {
        titleKey: 'billing.notices.insufficientCredits.title',
        messageKey: 'billing.notices.lowCredits.message'
    }
});

const translateWithFallback = (translate, key, params) => {
    if (typeof translate !== 'function') {
        return key;
    }
    const translated = translate(key, params);
    if (typeof translated === 'string') {
        return translated;
    }
    return key;
};

/**
 * @deprecated 此函数将在 T-U1 (analysisGateway/quoteRun) 完成后被替换
 * 当前保留以维持现有流程，新的登录回流逻辑已迁移至 uploadLoginResumeDraft.js
 */
export async function runUploadDefaultChargeFlow({
    imageId,
    subscriptionStore,
    t,
    source = 'upload_direct'
}) {
    if (!featureCreditGovernanceV094) {
        console.info('[UploadCredit] governance disabled, skip default charge', {
            imageId,
            source
        });
        return { success: true, skipped: true };
    }

    try {
        await subscriptionStore.syncStatus();
    } catch (syncError) {
        console.warn('[UploadCredit] syncStatus failed, fallback to local subscription state', {
            source,
            message: syncError?.message || syncError
        });
    }

    let result;
    try {
        console.info('[UploadCredit] start default charge', {
            imageId,
            source
        });
        result = await runDefaultCharge({
            imageId,
            subscriptionStore
        });
    } catch (chargeError) {
        result = {
            success: false,
            errorCode: chargeError?.code || 'default_charge_failed'
        };
    }

    if (result.success) {
        console.info('[UploadCredit] default charge success', {
            imageId,
            source,
            status: result.status
        });
        return result;
    }

    console.warn('[UploadCredit] default charge failed', {
        imageId,
        source,
        errorCode: result.errorCode,
        message: result.message
    });

    const textConfig = chargeErrorTextMap[result.errorCode] || {
        titleKey: 'billing.modal.defaultTitle',
        messageKey: 'billing.modal.defaultMessage'
    };

    const totalCredits = Number(subscriptionStore?.credits?.total || 0);
    const message = result.errorCode === 'insufficient_credits'
        ? translateWithFallback(t, textConfig.messageKey, {
            requiredCredits: 1,
            totalCredits
        })
        : translateWithFallback(t, textConfig.messageKey);

    return {
        ...result,
        title: translateWithFallback(t, textConfig.titleKey),
        message,
        source,
        requiredCredits: 1,
        totalCredits
    };
}
